export default [
  {
    path: 'contratos/welcome',
    name: 'financeiroContaContrato-listar',
    component: () => import('../views/GeradorContratoWelcomeView.vue'),
    meta: {
      title: 'Buscar contratos',
    },
  },
  {
    path: 'contratos/add',
    name: 'financeiroContaContrato-cadastrar',
    component: () => import('../views/GeradorContratoFormView.vue'),
    meta: {
      title: 'Cadastrar contrato',
    },
  },
  {
    path: 'contratos/:id',
    name: 'financeiroContaContrato-editar',
    component: () => import('../views/GeradorContratoFormView.vue'),
    meta: {
      title: 'Editar contrato',
    },
  },
  {
    path: 'contratos/recebiveis',
    name: 'financeiroContaContrato-recebiveis',
    component: () => import('../views/GeradorRecebiveisFormView.vue'),
    meta: {
      title: 'Gerador de recebíveis',
    },
  },
];
